export const reqStatusArray = [
  { label: "pending" },
  { label: "approved" },
  { label: "rejected" },
  { label: "all" },
];

export const adminProcessedFilesHeadCells = [
  { id: "user", label: "Name", sorting: true },
  { id: "uploaded_file", label: "Uploaded File", sorting: true },
  { id: "template", label: "Module", sorting: true },
  { id: "version", label: "Module Version", sorting: true },
  { id: "country", label: "Country", sorting: true },
  { id: "updated_date", label: "Date & Time", sorting: true },
  { id: "status", label: "Status", sorting: true },
  { id: "output", label: "Output" },
];

export const userProcessedFilesHeadCells = [
  { id: "uploaded_file", label: "Uploaded File", sorting: true },
  { id: "template", label: "Module", sorting: true },
  { id: "version", label: "Module Version", sorting: true },
  { id: "country", label: "Country", sorting: true },
  { id: "updated_date", label: "Date & Time", sorting: true },
  { id: "status", label: "Status", sorting: true },
  { id: "output", label: "Output" },
];

//users

export const userHeadCells = [
  { id: "name", label: "Name", sorting: true, size: "large" },
  { id: "user_role", label: "User Role", sorting: true },
  { id: "email", label: "Email", sorting: true },
  { id: "templates", label: "Assign Module", sorting: false },
  { id: "group_name", label: "User Group", sorting: false },
  { id: "web_app_access", label: "Eligible Models", sorting: false },
  { id: "status", label: "Active / Inactive", sorting: false },
];

export const userGroupHeadCells = [
  { id: "group_name", label: "User Group" },
  { id: "allocated_users", label: "Assigned Users" },
  { id: "created_at", label: "Created Date & Time" },
  { id: "created_by", label: "Created By" },
  { id: "is_active", label: "Active / Inactive", size: "small" },
];

export const userGroupUserHeadCells = [
  { id: "name", label: "Name", },
  { id: "email", label: "Email" },
];

export const modelHeaders = [
  { id: "name", label: "Module", sorting: true },
  { id: "url", label: "Template", sorting: false },
  { id: "date", label: "Created Date & Time", sorting: true },
  { id: "created_by", label: "Created By", sorting: true },
];

export const SelectUserHead = [
  { id: 1, label: "Name", sorting: true },
  { id: 2, label: "User Role", sorting: true },
];

export const ActivityLogModuleTypeHead = [
  { id: "name", label: "Name", sorting: true },
  { id: "user_role", label: "User Role", sorting: true },
  { id: "email", label: "Email", sorting: true },
  { id: "activity_type", label: "Activity Type", sorting: true },
  { id: "activity", label: "Activity", sorting: true },
  { id: "effected_user", label: "Effected To", sorting: true },
  { id: "date", label: "Date & Time", sorting: true },
];

export const ActivityLogPageTypeHead = [
  { id: "name", label: "Name", sorting: true },
  { id: "user_role", label: "User Role", sorting: true },
  { id: "email", label: "Email", sorting: true },
  { id: "page_name", label: "Page Name", sorting: true },
  { id: "date", label: "Date & Time", sorting: true },
];

export const requestModelTableHeaders = [
  { id: "template", label: "Module", sorting: true },
  { id: "headers", label: "Headers", sorting: false },
  { id: "countries", label: "Countries", sorting: false },
  { id: "requested_date", label: "Requested Date & Time", sorting: true },
  { id: "status", label: "Approve Status", sorting: true },
  { id: "reason", label: "Reject Reason", sorting: false },
];

export const requestModelAccessDialogTableHeader = [
  { id: "template", label: "Module", sorting: true },
  { id: "headers", label: "Headers", sorting: false },
  { id: "countries", label: "Countries", sorting: false },
  { id: "access", label: "Request Access", sorting: false },
];

export const RequestStatusArray = [
  { label: "pending" },
  { label: "approved" },
  { label: "rejected" },
];

export const ModelPermissionManagementTableHeaders = [
  { id: "user", label: "Requested By", sorting: true },
  { id: "requested_date", label: "Requested Date & Time", sorting: true },
  { id: "template", label: "Access Request Module", sorting: true },
  { id: "status", label: "Approve/Reject", sorting: false },
  { id: "reason", label: "If Reject, Reason", sorting: true },
];

export const errorRemarks = ["Error_while_uploading_the_file"]; // add error remarks by replacing spaces with '_'

export const AdvanceSiteRefHeaders = [
  {
    id: "siteRef",
    label: "Site Ref",
    sorting: true,
    order: 1,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "oprtr",
    label: " Operator",
    sorting: true,
    order: 2,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "base",
    label: "BASE",
    sorting: true,
    order: 3,
    orderType: "asc",
    isActive: false,
    subHeadings: [
      { id: "download", label: "download" },
      { id: "upload", label: "upload" },
      { id: "rsrp", label: "rsrp" },
    ],
  },
  {
    id: "neighbour",
    label: "NEIGHBOUR",
    sorting: true,
    order: 4,
    orderType: "asc",
    isActive: false,
    subHeadings: [
      { id: "download", label: "download" },
      { id: "upload", label: "upload" },
      { id: "rsrp", label: "rsrp" },
    ],
  },
  {
    id: "radius",
    label: "RADIUS",
    sorting: true,
    order: 5,
    orderType: "asc",
    isActive: false,
    subHeadings: [
      { id: "download", label: "download" },
      { id: "upload", label: "upload" },
      { id: "rsrp", label: "rsrp" },
    ],
  },
];

export const AdvanceSiteRefHeaderStyles = {
  groupedHeads: [
    { id: "base", bgColor: "#EFE0E0" },
    { id: "neighbour", bgColor: "#E0EFE2" },
    { id: "radius", bgColor: "#EFEAE0" },
  ],
};

export const ACT_LOG_TYPE = {
  // activity log types
  MODULE_LOGS: "module_log",
  PAGE_LOGS: "page_log",
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const AdvanceCapacityHeaders = [
  {
    id: "enodbID",
    label: "Enod_b ID",
    sorting: true,
    order: 1,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "rsrp",
    label: "RSRP ()dbm",
    sorting: true,
    order: 2,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "rsrq",
    label: "RSRQ",
    sorting: true,
    order: 3,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "sinr",
    label: "SINR",
    sorting: true,
    order: 4,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month1",
    label: "Month 1",
    sorting: true,
    order: 5,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month2",
    label: "Month 2",
    sorting: true,
    order: 6,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month3",
    label: "Month 3",
    sorting: true,
    order: 7,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month4",
    label: "Month 4",
    sorting: true,
    order: 8,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month5",
    label: "Month 5",
    sorting: true,
    order: 9,
    orderType: "asc",
    isActive: false,
  },
  {
    id: "month6",
    label: "Month 6",
    sorting: true,
    order: 10,
    orderType: "asc",
    isActive: false,
  },
];

export const monthOrder = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

export const monthsByQuarter = {
  Q1: ["Jan", "Feb", "Mar"],
  Q2: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  Q3: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
  Q4: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
};

export const BORDER_LEVELS = [
  { label: "ADM1", value: "ADM1" },
  { label: "ADM2", value: "ADM2" },
  { label: "ADM3", value: "ADM3" },
];

export const TOP_MS_RADIO_DATA = [
  { label: "Signal Strength", value: "best_dbm", icon: "/assets/signal.png" },
  { label: "Download", value: "best_down", icon: "/assets/download.png" },
  { label: "Upload", value: "best_up", icon: "/assets/upload.png" },
  { label: "Signal Quality", value: "best_rsrq", icon: "/assets/No Signal.png" },
  { label: "S/N Ratio", value: "best_sinr", icon: "/assets/sinrIcon.png" },
  { label: "Market Share", value: "best_ms", icon: "/assets/marketShareIcon.png" },
];

export const TOP_MS_TRANSMISSION_DATA = [
  { label: "Data Received", value: "data_received", icon: "/assets/sinrIcon.png" },
  { label: "Data Transceived", value: "data_transceived", icon: "/assets/sinrIcon.png" },
  { label: "Data Transmitted", value: "data_transmitted", icon: "/assets/sinrIcon.png" },
];

export const OP_MS_RADIO_DATA = [
  { label: "Signal Strength", value: "l_rsrp", icon: "/assets/signal.png" },
  { label: "Download", value: "l_down", icon: "/assets/download.png" },
  { label: "Upload", value: "l_up", icon: "/assets/upload.png" },
  { label: "Signal Quality", value: "l_rsrq", icon: "/assets/No Signal.png" },
  { label: "S/N Ratio", value: "l_sinr", icon: "/assets/sinrIcon.png" },
  { label: "Quadrant", value: "quad", icon: "/assets/quadrantIcon.png" },
  { label: "Network Action", value: "action", icon: "/assets/networkActionIcon.png" },
  { label: "Market Share", value: "ms", icon: "/assets/marketShareIcon.png" },
  { label: "Market Share Rank", value: "ms_rank", icon: "/assets/marketShareRankIcon.png" },
];

export const OP_MS_TRANSMISSION_DATA = [
  { label: "Data Received", value: "data_received", icon: "/assets/sinrIcon.png" },
  { label: "Data Transceived", value: "data_transceived", icon: "/assets/sinrIcon.png" },
  { label: "Data Transmitted", value: "data_transmitted", icon: "/assets/sinrIcon.png" },
];

export const OP_MS_DIVISIONAL_TABLE_COLUMN = [
  { label: "MS Rank", field: "ms_rank",  textAlign: "center" },
  {
    label: "Market Share (MS%)",
    field: "ms_type",
    valueField:"ms",
    type: "colorDot",
    colSpan: 2,
    textAlign: "center",
    minWidth: window.devicePixelRatio >= 1.25 ? 80 : 70 ,
    sortName: "ms"
  },
  { label: "Market Share (MS%)", field: "ms", colSpan: 0, round: 1 },
  {
    label: "Signal Strength (NC) (Good%)",
    field: "nc_type",
    valueField:"g_rsrp",
    type: "colorDot",
    colSpan: 2,
    textAlign: "center",
    sortName: "g_rsrp",
    minWidth: 95
  },
  { label: "Signal Strength (NC) (Good%)", field: "g_rsrp", colSpan: 0 },
  
  {
    label: "Download (Good%)",
    field: "ne_type",
    valueField:"g_down",
    type: "colorDot",
    colSpan: 2,
    textAlign: "center",
    sortName: "g_down"
  },
  { label: "Download (Good%)", field: "g_down", colSpan: 0 },
  
  { label: "Upload (Good%)", field: "ne_type", valueField:"g_up", type: "colorDot", colSpan: 2, textAlign: "center", sortName: "g_up" },
  { label: "Upload (Good%)", field: "g_up", colSpan: 0 },
  { label: "Signal Strength (dBm)", field: "a_dbm", textAlign: "center", round: "0", minWidth: 95 },
  { label: "Download (Mbps)", field: "a_down", textAlign: "center" },
  { label: "Upload (Mbps)", field: "a_up", textAlign: "center" },
  { label: "S/N Ratio (dB)", field: "sinr", textAlign: "center", minWidth: 75 },
  { label: "Signal Quality (dB)", field: "rsrq", textAlign: "center", minWidth: 85 },
  { label: "Network Action", field: "action", textAlign: "center" },
  { label: "Quadrant", field: "quad", textAlign: "center" },
];

export const sortOrder = [
  "Excellent",
  "Good",
  "Fair",
  "Poor",
  "No Coverage",
  "No Data",
];

export const tabData = [
  { value: "Daily", label: "Daily" },
  { value: "Weekly", label: "Weekly" },
  { value: "Monthly", label: "Monthly" },
];

export const OP_MS_GEOHASH_TABLE_COLUMN = [
  { label: "Geohash", field: "geohash", textAlign: "center" },
  { label: "Demand Score", field: "d_score", textAlign: "center"  },
  {
    label: "Signal Strength (dBm)",
    field: "geo_rsrp_type",
    valueField:"rsrp",
    type: "colorDot",
    colSpan: 2,
    sortName: "rsrp",
    minWidth: 95
  },
  { label: "RSRP (dBm)", field: "rsrp", colSpan: 0, round: 0 },
  {
    label: "Download (Mbps)",
    field: "geo_down_type",
    valueField:"download",
    type: "colorDot",
    colSpan: 2,
    sortName: "download"
  },
  { label: "Download (Mbps)", field: "download", colSpan: 0 },
  {
    label: "Upload (Mbps)",
    field: "geo_up_type",
    valueField:"upload",
    type: "colorDot",
    colSpan: 2,
    sortName: "upload"
  },
  { label: "Upload (Mbps)", field: "upload", colSpan: 0 },
  { label: "S/N Ratio (dB)", field: "sinr", textAlign: "center", minWidth: 75  },
  { label: "Signal Quality (dB)", field: "rsrq", textAlign: "center", minWidth: 85  },
  { label: "Network Action", field: "action", textAlign: "center" },
  { label: "Quadrant", field: "quad", textAlign: "center" },
];


export const MS_GEOHASH_MARGINS_TYPES ={
  rsrp: "geo_rsrp_type",
  down: "geo_down_type",
  upload: "geo_up_type"
}

export const logoDetails = [
  { id: 'airtel', name: 'Airtel', imageUrl: "/assets/airtel-logo.png" },
  { id: 'hutch', name: 'Hutch', imageUrl: "/assets/hutch-logo.png" },
  { id: 'dialog', name: 'Dialog', imageUrl: "/assets/dialog-logo.png" },
  { id: 'mobitel', name: 'Mobitel', imageUrl: "/assets/mobitel-logo.png" },
];

export const IBS_BUILDING_TABLE_COLUMNS = [
  { label: "Data Group Name", field: "n", colSpan: 1, rowSpan: 2, type: "mainHeader" },
  { label: "Provider", field: "op", colSpan: 0, type: "subHeader" },
  // { label: "Max", field: "rsrp", type: "mainHeader" },  <== will be added dynamically
  { label: "IBS Score", field: "s", type: "mainHeader", rowSpan: 2 },
  { label: "Total Devices", field: "d" , type: "mainHeader", rowSpan: 2 },
  { label: "Total Samples", field: "r" , type: "mainHeader", rowSpan: 2 },
  { label: "Building Attribute", field: "bui_atr", colSpan: 7 , type: "mainHeader" },
  // { label: "RSRP", field: "RSRP_Max" , type: "attrSubHeader" },  <== will be added dynamically
  // { label: "ADM1", field: "a1" , type: "subHeader", common: true }, <== will be added dynamically
  // { label: "ADM2", field: "a2" , type: "subHeader", common: true }, <== will be added dynamically
  // { label: "ADM3", field: "a3" , type: "subHeader", common: true }, <== will be added dynamically
  { label: "Lat", field: "lt" , type: "subHeader", common: true, round: 5 },
  { label: "Lon", field: "ln" , type: "subHeader", common: true, round: 5 },
  { label: "Area (m)", field: "a" , type: "subHeader", common: true, round: 3 },
  { label: "Type", field: "t" , type: "subHeader", common: true },
]

export const ADM_LVL_NAME_MAP = {
  ADM1 : "adminLevel1", 
  ADM2 : "adminLevel2", 
  ADM3 : "adminLevel3",
}

export const defaultGradientArr = [
  {color: '#959595', pos: 0},
  {color: '#FCEA0F', pos: 0.5},
  {color: '#FF0000', pos: 1}
]